import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shadcn/select';
import { useChatbotList } from '@/hooks';
import { useAdminSettings } from '@/hooks/useAdminSettings';
import { ADMIN_SETTINGS_KEY, apiUrl, fetchWithAuth } from '@/utils';
import { Label } from '@radix-ui/react-label';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const AdminSettings = () => {
  const { data: settings } = useAdminSettings();
  const { data: list } = useChatbotList();

  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: async (chatId: string) => {
      const response = await fetchWithAuth(`${apiUrl}/admin-settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chatId,
        }),
      });
      if (!response.ok) {
        throw new Error('failed to update');
      }
    },
    onSuccess: () => {
      toast('updated settings');
      queryClient.invalidateQueries({ queryKey: [ADMIN_SETTINGS_KEY] });
    },
    onError: () => {
      toast('issue updating settings');
    },
  });

  if (settings && list) {
    const options = list.map((e) => ({
      key: e.id,
      value: e.name,
    }));

    return (
      <div>
        <Label>Feedback bot</Label>
        <Select
          value={settings.chatId || ''}
          onValueChange={(val) => {
            mutate(val);
          }}
        >
          <SelectTrigger className="h-9">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {options.map(({ key, value }) => (
              <SelectItem key={key} value={key}>
                {value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }
  return <div>Failed to get data</div>;
};

export default AdminSettings;
